// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  height: 100vh;
}

/* Left side */
.login-left {
  flex: 1 1;
  background-color: #163968; /* Blue background like screenshot */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white; /* White text */
  padding: 40px;
}

.login-left img {
  max-width: 80%;
  height: auto;
  margin-bottom: 20px;
}

.login-left h1 {
  margin-bottom: 10px;
  font-weight: 1000;
  font-family: Rockwell;
  font-size: 4rem;
}

.login-left p {
  font-size: 1rem;
  text-align: center;
  max-width: 300px;
}

.login-right {
  flex: 1 1;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 80px;
  padding-top: 80px;
}

.login-right h2 {
  margin-bottom: 20px;
}

.login-right h3 {
  margin-bottom: 20px;
  font-weight: 700;
  font-family: 'Georgia', serif;
  color: #163968;
  font-size: 1.5rem;
}

.login-right form {
  display: flex;
  flex-direction: column;
  width: 250px;
}

.login-right input {
  padding: 10px;
  margin: 5px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  padding: 10px;
  margin-top: 10px;
  background: rgb(18, 7, 7);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background: #0f5ec2;
}

.error {
  color: red;
  font-size: 0.9rem;
  margin-top: 5px;
}

.login-logo {
  height: 150px;
  width: 150px;
  object-fit: contain;
  margin-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./src/css/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;AACf;;AAEA,cAAc;AACd;EACE,SAAO;EACP,yBAAyB,EAAE,oCAAoC;EAC/D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAE,eAAe;EAC7B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".login-container {\r\n  display: flex;\r\n  height: 100vh;\r\n}\r\n\r\n/* Left side */\r\n.login-left {\r\n  flex: 1;\r\n  background-color: #163968; /* Blue background like screenshot */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white; /* White text */\r\n  padding: 40px;\r\n}\r\n\r\n.login-left img {\r\n  max-width: 80%;\r\n  height: auto;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.login-left h1 {\r\n  font-size: 1.8rem;\r\n  margin-bottom: 10px;\r\n  font-weight: 1000;\r\n  font-family: Rockwell;\r\n  font-size: 4rem;\r\n}\r\n\r\n.login-left p {\r\n  font-size: 1rem;\r\n  text-align: center;\r\n  max-width: 300px;\r\n}\r\n\r\n.login-right {\r\n  flex: 1;\r\n  background-color: white;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  padding: 80px;\r\n  padding-top: 80px;\r\n}\r\n\r\n.login-right h2 {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.login-right h3 {\r\n  margin-bottom: 20px;\r\n  font-weight: 700;\r\n  font-family: 'Georgia', serif;\r\n  color: #163968;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.login-right form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 250px;\r\n}\r\n\r\n.login-right input {\r\n  padding: 10px;\r\n  margin: 5px 0;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\nbutton {\r\n  padding: 10px;\r\n  margin-top: 10px;\r\n  background: rgb(18, 7, 7);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\nbutton:hover {\r\n  background: #0f5ec2;\r\n}\r\n\r\n.error {\r\n  color: red;\r\n  font-size: 0.9rem;\r\n  margin-top: 5px;\r\n}\r\n\r\n.login-logo {\r\n  height: 150px;\r\n  width: 150px;\r\n  object-fit: contain;\r\n  margin-bottom: 40px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
